import React, { lazy, Suspense, useEffect, useState } from 'react'
import { Route, Routes, useLocation, Navigate } from 'react-router-dom'
import ContactHeader from './components/ContactHeader';
import Header from './components/Header';
import Container from './Container';
import Footer from './components/Footer';
import ContactFooter from './components/ContactFooter';
import ScrollToTop from './components/ScrollToTop';
import './i18n'; 
import './App.css';
import './styles/rtl.css'
import '@fontsource/cairo';
import { LanguagesProvider } from './context/LanguagesContext';
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Home = lazy(() => import('./Pages/Home.jsx'));
const HomeMobile = lazy(() => import('./pagesMobile/HomeMobile.jsx'));
const About = lazy(() => import('./Pages/About.jsx'));
const AboutMobile = lazy(() => import('./pagesMobile/AboutMobile.jsx'));
const Specialities = lazy(() => import('./Pages/Specialities.jsx'));
const SpecialitiesMobile = lazy(() => import('./pagesMobile/SpecialitiesMobile.jsx'));
const Galerie = lazy(() => import('./Pages/Galerie.jsx'));
const GalerieMobile = lazy(() => import('./pagesMobile/GalerieMobile.jsx'));
const Contact = lazy(() => import('./Pages/Contact.jsx'));
const ContactMobile = lazy(() => import('./pagesMobile/ContactMobile.jsx'));


function App() {
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation(); // Get the current route
  
  // Check the window width and update the isMobile state
    useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1190);
    };

    // Set the initial state
    handleResize();

    // Listen for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <LanguagesProvider>
        <div className={`App `}>
          <ScrollToTop />
          <div className='w-full'>
            {!isMobile && 
            <div className='pt-10 bg-white w-full px-16 xxxl:px-20'>
                <ContactHeader dis={isMobile}/>
            </div>}
            
            <div className={`bg-white  z-[10000] w-full ${isMobile ? 'fixed top-0 px-0' : 'sticky top-0 mt-10 px-16 xxxl:px-20'}`}>
                <Header dis={isMobile}/>
            </div>
            <div className='overflow-hidden w-full'>
              <Container>
                  <Suspense fallback={<div className='w-full h-screen flex justify-center items-center'><AiOutlineLoading3Quarters className='animate-spin text-5xl text-primary'/></div>}>
                      <Routes location={location} key={location.pathname}>
                          <Route path="/" element={<Navigate to="/home" replace />} />
                          <Route path='/home' element={isMobile ? <HomeMobile/> : <Home/>} smooth duration={500} />
                          <Route path='/about' element={isMobile ? <AboutMobile/> : <About/>} smooth duration={500} />
                          <Route path='/specialities' element={isMobile ? <SpecialitiesMobile/> : <Specialities/>} smooth duration={500} />
                          <Route path='/galerie' element={isMobile ? <GalerieMobile/> : <Galerie/>} smooth duration={500} />
                          <Route path='/contact' element={isMobile ? <ContactMobile/> : <Contact/>} smooth duration={500} />
                      </Routes>
                  </Suspense>
              </Container>
            </div>
          </div>
          {location.pathname !== '/contact' && (
              <div className={` ${isMobile ? 'px-4 sm:px-10' : 'px-24 '} w-full pt-10 md:pt-20`}>
                <ContactFooter/>
              </div>
            )}
          <div className='w-full'>
              <Footer/>
          </div>
        </div>
    </LanguagesProvider>
  );
}

export default App;
